/** @module Merchandising/AggregateFromStyleColorwaysController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/action/FormData",
	"csi/config",
	"csi/def/ViewRef",
	"csi/table/AggregateFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml"
], function(declare,lang,_,FormData,config,ViewRef,AggregateFrom,ActionControllerMixin,xml) {

	/**
	 * Determine if Colorway way is already linked
	 * @param {Object<string,boolean>} mapColorways
	 * @param {Context} ctx
	 * @param {FormData} fd
	 * @return {boolean}
	 */
	function _isSelected(mapColorways, ctx, fd) {
		var urlColorway = ctx.getNodeURL();
		return mapColorways[urlColorway];
	}

	return declare([AggregateFrom, ActionControllerMixin], {
		_fdOption: null,

		/**
		 * Determine if node is already selected
		 */
		onFormData: function(fd) {
			fd.m_fAggregateSelected = lang.partial(_isSelected, this._getMapColorways());
		},

		/**
		 * Returns the map of Colorways
		 * @return {Object<string,boolean>}
		 */
		_getMapColorways: function() {
			var mpv = this.getParent();
			var cache = this.getCache();
			var optionVersions = cache.getChildren(mpv, "Children");
			var mapColorways = {};
			_.each(optionVersions, function(version){
				mapColorways[version.Colorway] = true;
			});
			return mapColorways;
		},

		/**
		 * Adding the wizard popup in case of multiple Option Subtypes
		 * @param {ViewRef} vr
		 */
		getActionView: function(vr) {
			var mpv = this.getParent();
			var cache = this.getCache();
			var mp = cache.getNode(mpv.__Parent__);
			var subtypes = config.getNodeSetting(mp, "ChildrenSubtypes");
			if (subtypes.length > 0) {
				vr = new ViewRef();
				vr.m_id = "AggregateFromStyleColorwaysWizard";
			}
			return this.inherited(arguments, [vr]);
		},

		/**
		 * @override
		 * Apply filters to Colorways table
		 */
		onWizardViewCreate: function(wizard, page, view) {
			var index = wizard.getIndexOfPage(page);
			if (index == 1) {
				this.applyActionFilters(view);
			}
		},

		/**
		 * @override
		 * Disable the finish button if no colorways are selected
		 */
		disableFinish: function(wizard, page, index) {
			return index==1 && !this.m_formData.getSelectedNodes().length > 0;
		},

		/**
		 * @override
		 * Apply filters to Colorways table
		 */
		onNextPage : function(wizard, currentPage, nextPage, bFinish) {
			var nPage = wizard.getIndexOfPage(nextPage);
			var dfd;
			var fd;
			var bRefresh = false;

			switch (nPage) {
				case 0:
					fd = this._fdOption = this._fdOption || new FormData(this);
					var mpv = this.getParent();
					var mp = this.m_cache.getNode(mpv.__Parent__);
					//Parent of MerchOption needs to be the MerchProduct, so setting the parent node here.
					fd.m_parentNode = mp;
					break;
				case 1:
					// initialize form data if not already done - this page uses
					// form data from this controller
					fd = this.getFormData();
					//context of the second view needs to be the MerchProductVersion for the Path (“Child:Style”) on the ViewRef to work.
					fd.setNode(this.getParent());
					break;
			}
			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;

		},

		/**
		 * @override
		 * Adding Subtype to the call
		 */
		_writeRequestParameters: function(call) {
			call.addParameter("Subtype", xml.ATTR_REF, this._fdOption.getFieldValue("Subtype"));
			this.inherited(arguments);
		}
	});
});